import React, { Component, Fragment } from "react";
import Fade from "react-reveal/Fade";
import { connect } from "react-redux";
import store from "../store";
import { getLastJobs } from "../actions";
import JobCompact from "../components/JobCompact";
import ContactForm from "../components/ContactForm";
import SearchForm from "../components/SearchForm";
import { _t } from "../util/Translator";

class Home extends Component {
  state = {
  };

  componentDidMount() {
    store.dispatch(getLastJobs());
  }

  onClick = (item) => {
    this.props.history.push('/jobs/' + item.id);
  }

  render() {

    return (
      <Fragment>
        <div className="container-fluid zero-container">
          <div className="row landing-background">
            <div className="ribete-rojo" />
            <div className="col-md-2">&nbsp;</div>
            <div className="col-md-6">
                <div className="row transparent-panel">
                  <SearchForm history={this.props.history} selectedLanguage={this.props.selectedLanguage}/>
              </div>
            </div>
            <div className="col-md-4">
              <div className="home-subtitle font-header-light d-flex align-items-center">{_t("home.subtitle")}</div>
            </div>
          </div>
        </div>  
        
        <div className="site-section">
          <div className="container">
            <div className="row pb-3">
              <div className="section-marker">
                <div className="section-marker-title font-header-light">{_t("home.sectionTopJobs")}</div>
              </div>
            </div>
            <div className="row align-items-top">
              <div className="col-md-12">
                <div className="row align-items-top">
                {this.props.lastJobs.map((value, index) => {
                  return <JobCompact key={index} job={value} onClick={()=> this.onClick(value)}/>
                })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="SECTION_COMPANY" className="site-section">
          <div className="container">
            <div className="row pb-3">
              <div className="section-marker">
                <div className="section-marker-title font-header-light">{_t("home.sectionCompany")}</div>
              </div>
            </div>
            <Fade right>
              <div className="row align-items-top text-center">
                <div className="col-md-4 h4 font-header-light">Headhunting</div>
                <div className="col-md-4 h4 font-header-light">Selection App</div>
                <div className="col-md-4 h4 font-header-light">Digital Recruitment</div>
              </div>
            </Fade>
            <div className="row align-items-top">  
              <div className="col-md-12">
                <Fade big>
                <div className="row justify-content-center">
                  <img src={`${process.env.PUBLIC_URL}/assets/services.png`} className="company-image" /> 
                </div>
                </Fade>
              </div>
            </div>
            <Fade right>
              <div className="row align-items-top text-center">
                <div className="col-md-4 h4 font-header-light">Outsourcing</div>
                <div className="col-md-4 h4 font-header-light">RPO Services</div>
                <div className="col-md-4 h4 font-header-light">HR Evaluation Process</div>
              </div>
            </Fade>
          </div>
        </div>

        <div id="SECTION_CONTACTO" className="site-section">
          <div className="container">
            <div className="row pb-3">
              <div className="section-marker"> 
                <div className="section-marker-title font-header-light">{_t("home.sectionContactUs")}</div>
              </div>
            </div>
            <div className="row align-items-top">
              <div className="col-md-6">
                <div className="h3 font-header-light">{_t("home.contactSubtitle")}</div>
                <p>
                {_t("home.contactTextP1")}
                <br/>
                {_t("home.contactTextP2")}
                </p>
              </div>
              <div className="col-md-6">
                <ContactForm selectedLanguage={this.props.selectedLanguage}/>
              </div>
            </div>
          </div>
        </div>

      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  console.log("lastJobs:", state.lastJobs);
  return { lastJobs: state.lastJobs };
};

export default connect( mapStateToProps, {
  getLastJobs
})(Home);